import React from "react";
import SpecialNIPL from "../../assets/icons/SpecialNIPL";
import NoImage from "../../assets/images/NoImage.jpg";
import PPNIcon from "../../assets/icons/PPNIcon";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { formatDateTimeRange } from "../../helpers/dateRangeFormatter";

const CardUnit = (props) => {
  const defaultFunc = () => {};
  const { auction } = props;
  const isOnlineBid = !["CLOSE-BID", "TIME-BID"].includes(auction?.auction_category);
  const dateRange = formatDateTimeRange(
    auction?.date_start,
    auction?.time_start,
    isOnlineBid ? auction?.date_start : auction?.date_finish,
    auction?.time_finish
  );
  // Sama seperti mobile (CardAuctionProduct): badge Live & PPN keduanya overlay
  // di pojok kanan-bawah foto. Kalau dua-duanya tampil bersamaan, Live distack
  // di atas PPN supaya tidak tabrakan.
  const isLive = props?.auction?.is_started === 1 || props?.auction?.status === "STARTED";
  const hasPpn = props.ppn_include === 0;
  let content = (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <div
        className="card-unit-header"
        style={
          props.pictures?.length > 0
            ? { background: `url("${props.pictures[0].image_url}")`, position: "relative" }
            : { background: `url(${NoImage})`, position: "relative" }
        }
      >
        <div className="overlay">{props.grade && <div className="card-unit-grade">Grade {props.grade}</div>}</div>
        {isLive && (
          <div style={{ position: "absolute", right: "8px", bottom: hasPpn ? "36px" : "8px" }}>
            <BadgeAuctionType label="Live" className="metode red" />
          </div>
        )}
        {hasPpn && (
          <div className="card-unit-ppn" style={{ position: "absolute", right: "8px", bottom: "8px" }}>
            <span className="icon-ppn mr-6">
              <PPNIcon />
            </span>
            PPN {props.ppn_buyer_fee}%
          </div>
        )}
      </div>
      <div className="unit-lot-wrapper">
        <div className="card-unit-lot">Lot {props?.lot_number}</div>
        {(props.specialNIPL > 1 || props.specialNIPL === "true") && (
          <div className="card-unit-lot c-orange">
            <span className="icon-nipl">
              <SpecialNIPL />
            </span>
            <span>Special NIPL</span>
          </div>
        )}
      </div>
      <div className="card-unit-body" style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <h5 className="card-unit-name">{props?.nama || "-"}</h5>
        <div className="card-unit-tag">
          {props?.tags?.length > 0
            ? props.tags.map((data, i) => <span key={"tag" + i}>{data?.name || "-"}</span>)
            : null}
        </div>
        <div className="card-unit-price-detail">
          <div className="card-unit-price d-table">
            Rp{" "}
            <span
              style={{
                textDecoration: props?.is_cancel_auction ? "line-through" : "none",
                textDecorationColor: "red",
                textDecorationThickness: "3px",
              }}
            >
              {props.price ? props.price.toLocaleString() : "-"}
            </span>
          </div>
        </div>

        {props.unitType === "Motor" || props.unitType === "Mobil" ? (
          <div className="card-unit-spec" style={{ display: "flex", gap: "8px" }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              {props?.unitDetail?.year !== undefined ? (
                <div className="card-unit-spec-detail mb-2">
                  <span id="header">Tahun</span>
                  <span id="detail">
                    {props?.unitDetail?.year && props?.unitDetail?.year !== "null" && props?.unitDetail?.year !== ""
                      ? props?.unitDetail?.year
                      : "-"}
                  </span>
                </div>
              ) : null}
              {props?.unitDetail?.police_number != null ? (
                <div className="card-unit-spec-detail mb-2">
                  <span id="header">Plat Nomor</span>
                  <span id="detail" style={{ wordBreak: "break-all", overflowWrap: "break-word" }}>
                    {props?.unitDetail?.police_number &&
                    props?.unitDetail?.police_number !== "null" &&
                    props?.unitDetail?.police_number !== ""
                      ? props?.unitDetail?.police_number
                      : "-"}
                  </span>
                </div>
              ) : null}
              {props?.unitDetail?.fuel !== undefined ? (
                <div className="card-unit-spec-detail">
                  <span id="header">Bahan Bakar</span>
                  <span id="detail">
                    {props?.unitDetail?.fuel && props?.unitDetail?.fuel !== "null" && props?.unitDetail?.fuel !== ""
                      ? props?.unitDetail?.fuel
                      : "-"}
                  </span>
                </div>
              ) : null}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              {props?.unitDetail?.odometer !== undefined ? (
                <div className="card-unit-spec-detail mb-2">
                  <span id="header">Odometer</span>
                  <span id="detail">
                    {props?.unitDetail?.odometer &&
                    props?.unitDetail?.odometer !== "null" &&
                    props?.unitDetail?.odometer !== ""
                      ? `${props?.unitDetail?.odometer} KM`
                      : "-"}
                  </span>
                </div>
              ) : null}
              <div className="card-unit-spec-detail mb-2">
                <span id="header">Masa Berlaku</span>
                <span id="detail">
                  {props?.unitDetail?.validityPeriod &&
                  props?.unitDetail?.validityPeriod !== "null" &&
                  props?.unitDetail?.validityPeriod !== ""
                    ? props?.unitDetail?.validityPeriod
                    : "-"}
                </span>
              </div>
              {props?.unitDetail?.transmisi !== undefined ? (
                <div className="card-unit-spec-detail">
                  <span id="header">Transmisi</span>
                  <span id="detail">
                    {props?.unitDetail?.transmisi &&
                    props?.unitDetail?.transmisi !== "null" &&
                    props?.unitDetail?.transmisi !== ""
                      ? props?.unitDetail?.transmisi
                      : "-"}
                  </span>
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
      {props.auction !== undefined && (
        <div className="card-unit-footer d-flex footer-label p-2" style={{ flexShrink: 0 }}>
          <div className="time-location">
            <>
              <b style={{ fontSize: 13 }}>{props?.auction?.location_name?.replace("Caready ", "") || "Caready"}</b>
              <p className="mb-0" style={{ fontSize: 13 }}>
                {dateRange}
              </p>
            </>
          </div>
          {props?.auction?.auction_category === "CLOSE-BID" ? (
            <BadgeAuctionType label="CLOSE BID" className="metode purple" />
          ) : props?.auction?.auction_category === "TIME-BID" ? (
            <BadgeAuctionType label="TIME BID" className="metode blue" />
          ) : (
            <BadgeAuctionType label="ONLINE BID" className="metode red" />
          )}
        </div>
      )}
    </div>
  );

  if (props?.link) {
    content = (
      <Link to={props.link} className="no-underline	">
        {content}
      </Link>
    );
  }

  return (
    <div
      className={`card-unit cursor-pointer h-100 ${props.live === 1 ? "live" : ""}`}
      onClick={props.onClick || defaultFunc}
      style={{ display: "flex", flexDirection: "column" }}
    >
      {content}
    </div>
  );
};

const BadgeAuctionType = ({ label, className }) => {
  const getBorderColor = () => {
    if (className.includes("purple")) return "#8B5CF6";
    if (className.includes("blue")) return "#3B82F6";
    if (className.includes("red")) return "#EF4444";
    if (className.includes("green")) return "#10B981";
    return "#6B7280";
  };

  const getTextColor = () => {
    if (className.includes("purple")) return "#8B5CF6";
    if (className.includes("blue")) return "#3B82F6";
    if (className.includes("red")) return "#EF4444";
    if (className.includes("green")) return "#10B981";
    return "#6B7280";
  };

  return (
    <div
      className={className}
      style={{
        whiteSpace: "nowrap",
        backgroundColor: "transparent",
        color: getTextColor(),
        padding: "4px 12px",
        border: `1px solid ${getBorderColor()}`,
        borderRadius: "4px",
        fontSize: "12px",
        fontWeight: "600",
        display: "inline-block",
      }}
    >
      {label}
    </div>
  );
};

export default CardUnit;
